<template>
  <div class="tab-btn label-content">
    <div class="header" style="margin-bottom: 10px">
      <el-button type="primary" size="mini" @click="handleGenerate"
        >生成定额库</el-button
      >
    </div>
    <div class="content">
      <div class="top">
        <LeftRightBox :leftWidthDefault="300" height="100%">
          <template slot="left">
            <SimpleTable
              :showIndex="false"
              table-code="LibQuotaLeft"
              ref="LibQuotaLeft"
              :loading="loading.left"
              :columns="columns.left"
              :data="tableData.left"
              @row-select="handleRowSelectLeft"
            />
          </template>
          <template slot="right">
            <SimpleTable
              :showIndex="false"
              table-code="LibQuotaRight"
              ref="LibQuotaRight"
              :loading="loading.right"
              :columns="columns.right"
              :data="tableData.right"
              @row-select="handleRowSelectRight"
            />
          </template>
        </LeftRightBox>
      </div>
      <div class="bottom">
        <SimpleTable
          :showIndex="false"
          table-code="LibQuotaBottom"
          ref="LibQuotaBottom"
          :loading="loading.bottom"
          :columns="columns.bottom"
          :data="tableData.bottom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import { sortRecords } from '@/utils/index'

export default {
  name: 'LibQuota',
  inject: ['detailsVm'],
  components: {
    SimpleTable,
    LeftRightBox
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: {
        left: false,
        right: false,
        bottom: false
      },
      tableData: {
        left: [],
        right: [],
        bottom: []
      },
      columns: {
        left: [{ field: 'name', title: '定额分类', tree: true }],
        right: [
          { field: 'code', title: '编码' },
          { field: 'name', title: '子目名称' },
          { field: 'unit', title: '单位' },
          { field: 'keywords', title: '关键词' }
        ],
        bottom: [
          { field: 'code', title: '编码', tree: true },
          { field: 'type', title: '类别' },
          { field: 'name', title: '人材机名称' },
          { field: 'spec', title: '规格型号' },
          { field: 'unit', title: '单位' },
          { field: 'content', title: '地区含量' },
          { field: 'keywords', title: '关键词' }
        ]
      }
    }
  },
  watch: {
    basicInfo: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      if (!this.basicInfo.id) return
      this.getLeftData()
    },

    async getLeftData() {
      this.tableData.left = []
      this.tableData.right = []
      this.tableData.bottom = []
      this.loading.left = true
      const res = await this.$service.get(
        '/quota-library/quota-classify/tree',
        {
          quotaLibraryId: this.basicInfo.id
        }
      )
      this.tableData.left = sortRecords(res.data || [])
      this.loading.left = false
      this.$refs.LibQuotaLeft.initialized(0, 1)
    },
    async getRightData(row) {
      this.tableData.right = []
      this.tableData.bottom = []
      this.loading.right = true
      const res = await this.$service.get('/quota-library/quota-item/list', {
        quotaLibraryId: this.basicInfo.id,
        quotaClassifyId: row.id
      })
      this.tableData.right = sortRecords(res.data || [])
      this.loading.right = false
      this.$refs.LibQuotaRight.initialized(0, 1)
    },
    async getBottomData(row) {
      this.tableData.bottom = []
      this.loading.bottom = true
      const res = await this.$service.get(
        '/quota-library/quota-resource/tree',
        {
          quotaItemId: row.id
        }
      )
      this.tableData.bottom = sortRecords(res.data || [])
      this.loading.bottom = false
    },

    handleRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getRightData(obj)
    },

    handleRowSelectRight(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.getBottomData(obj)
    },

    async handleGenerate() {
      this.detailsVm.loading = true
      const res = await this.$service.post(
        '/quota-library/generate/' + this.basicInfo.id
      )
      this.detailsVm.loading = false
      if (res.code === 200) {
        this.init()
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style scoped lang="less">
.label-content {
  height: 530px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .content {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    overflow: hidden;
    > div {
      width: 100%;
      overflow: hidden;
    }
    .top {
      flex: 1;
    }
    .bottom {
      height: 180px;
    }
  }
}
</style>
